import React from "react";

import Divider from "../Divider";
import Image from "../Image";
import Avatar from "../Avatar"
import Typography from "../Typography";

import './index.scss';

const mockedLanguages = [
    {
        name: "English",
        short: "US"
    },
    {
        name: "Spanish",
        short: "ES"
    }

]

export default class LanguageSelector extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            displayLanguages: false,
            selectedLanguage: "US"
        }
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClick, false);
    }
    
    componentWillUnmount() {
        document.removeEventListener('click', this.handleClick, false);
    }

    handleClick = (e) => {
        if (this.node){
          if ( !this.node.contains(e.target) ){
            this.setState({ displayLanguages: false })
          }
        }
    }

    renderLanguagesList = () => {
        return (
            mockedLanguages.map((language, index) => {
                return (
                    <React.Fragment>
                         <div onClick={() => this.setState({ selectedLanguage: language.short, displayLanguages: false })} className={"languageItem " + ( language.short === this.state.selectedLanguage ? "selected" : "")}>
                            <Avatar>
                            <Image  
                                alt={language.name}
                                source={"http://catamphetamine.gitlab.io/country-flag-icons/3x2/" + language.short + ".svg"} 
                            />
                            </Avatar>
                            <Typography className="h400">{language.name + " (" + language.short + ") "}</Typography>
                        </div>
                        { index + 1 < mockedLanguages.length && <Divider /> }
                    </React.Fragment>
                )
            })
        )
    }

    render(){
        const { state } = this;
        const { displayLanguages, selectedLanguage } = state;

        return(
            <div className="languageSelector" ref={node => this.node = node}>
                <Avatar onClick={() => this.setState({ displayLanguages: true })}>
                    <Image 
                        alt={selectedLanguage}
                        source={"http://catamphetamine.gitlab.io/country-flag-icons/3x2/" + selectedLanguage + ".svg"} 
                    />
                </Avatar>
                { displayLanguages &&
                    <div className="languageDrop">
                        {this.renderLanguagesList()}
                    </div>
                }
            </div>
        )
    }
}